export const TOUR_FEEDBACK_ISSUES = [
    { label: 'Too small', value: 'Too small' },
    { label: 'Poor value', value: 'Poor value' },
    { label: "Didn't like area", value: "Didn't like area" },
    { label: 'Not as advertised', value: 'Not as advertised' },
    { label: "Didn't feel right", value: "Didn't feel right" },
    { label: 'Unprofessional agent', value: 'Unprofessional agent' },
];
